import { render, staticRenderFns } from "./image-resize-modal.vue?vue&type=template&id=32128af4"
import script from "./image-resize-modal.vue?vue&type=script&lang=js"
export * from "./image-resize-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports